/*jslint browser */
/*global process */

import Dump from "../model/dump.model";

var $ = jQuery;

/**
 *
 */
export default class AdminBarView
{
    /**
     *
     * @private
     */
    private _dump: JQuery;
    /**
     *
     * @private
     */
    private _container: JQuery;
    /**
     *
     * @private
     */
    private _dumpsCount: JQuery;
    /**
     *
     * @private
     */
    private _dumpCountResult: JQuery;
    /**
     *
     * @private
     */
    private _cache: JQuery;
    /**
     *
     * @private
     */
    private _cacheContainer: JQuery;
    /**
     *
     * @private
     */
    private _cacheCount: JQuery;
    /**
     *
     * @private
     */
    private _cacheCountResult: JQuery;
    /**
     *
     * @private
     */
    private _database: JQuery;
    /**
     *
     * @private
     */
    private _databaseContainer: JQuery;
    /**
     *
     * @private
     */
    private _databaseResult: JQuery;
    /**
     *
     * @private
     */
    private _databaseCount: JQuery;

    /**
     *
     */
    constructor() {
        this.registerObjects();
    }

    /**
     *
     */
    public getDumpObject(): JQuery {
        return this._dump;
    }

    /**
     *
     */
    public renderDumps(dumps: Dump[]): void {
        dumps.forEach(dump => this._container.append(dump.message));
    }

    /**
     *
     */
    public renderDumpsCount(count: number): void {
        this._dumpCountResult.html(count);
        if(count > 0) {
            this._dumpCountResult.addClass('speed-5');
        }
    }

    /**
     *
     */
    public renderCache(): void {
        this._cacheContainer.html(this._cache.html());
    }

    /**
     *
     */
    public renderCacheCount(): void {
        this._cacheCountResult.html($('.xt-cache-count').data('count'));
    }

    /**
     *
     */
    public renderDatabase(): void {
        this._databaseContainer.html(this._database.html());
    }

    /**
     *
     */
    public renderDatabaseCount(): void {
        let err = $('.xt-database-count').data('err');
        if(parseInt(err) > 0) {
            err = '<span style="color: red">' + err + '</span>';
        }

        this._databaseResult.html(' xt: '+$('.xt-database-count').data('xt')+' wp: '+$('.xt-database-count').data('wp')+' err: ' +err);
    }

    /**
     *
     * @private
     */
    private registerObjects(): void {
        this._dump = $('.xt-dump');
        this._dumpsCount = $('.xt-dumps-count');
        this._container = $('#wp-admin-bar-x-tools-dump-content').find('.xt-bar-container');
        this._dumpCountResult = $('.xt-dump-count-result');
        this._cache = $('.xt-cache');
        this._cacheContainer = $('.xt-cache-container');
        this._cacheCountResult = $('.xt-cache-count-result');
        this._cacheCount = $('.xt-cache-count');
        this._database = $('.xt-database');
        this._databaseContainer = $('#wp-admin-bar-x-tools-database-content').find('.xt-bar-container');
        this._databaseResult = $('.xt-database-result');
        this._databaseCount = $('.xt-database-count');
    }
}